import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsAccountHistory } from "@/models/admin/warrantsAccountHistory/warrantsAccountHistory"
import { IWarrantsAccountHistory } from "@/models/admin/warrantsAccountHistory/warrantsAccountHistory.types"

/**
 * A single `warrants_accounts_history` row as returned by Hasura. Mirrors the
 * generated `Financials_Warrants_Accounts_History` row; kept as a narrow type
 * so the parser only depends on the columns it actually reads.
 */
export type WarrantsAccountHistoryRaw = {
  id: number
  account_number: string
  status: string
  current_status?: string | null
  next_status?: string | null
  message?: string | null
  created_at: string
  updated_at: string
  deleted_at?: string | null
}

export const WarrantsAccountHistoryParser: IParser<
  IWarrantsAccountHistory,
  WarrantsAccountHistoryRaw
> = {
  toDomain(data) {
    try {
      // Hasura `timestamp` columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsAccountHistory(
        data.id,
        data.account_number,
        data.status,
        data.current_status ?? null,
        data.next_status ?? null,
        data.message ?? null,
        dayjsUTC(data.created_at),
        dayjsUTC(data.updated_at),
        data.deleted_at ? dayjsUTC(data.deleted_at) : null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
